import type { CSSProperties, ReactNode } from "react";
import { Icon, type IconName } from "./Icon.js";

/** Portato da `components/data/EmptyState.jsx` del design system. */
export interface EmptyStateProps {
  icon?: IconName;
  title: ReactNode;
  body?: ReactNode;
  action?: ReactNode;
  style?: CSSProperties;
}

export function EmptyState({ icon = "receipt", title, body, action, style }: EmptyStateProps) {
  return (
    <div style={{ textAlign: "center", padding: "40px 24px", ...style }}>
      <div
        style={{
          width: 64,
          height: 64,
          margin: "0 auto",
          borderRadius: 22,
          // Sul fondo incassato un cerchio grigio non si distinguerebbe.
          background: "var(--surface-card)",
          border: "1px solid var(--border-default)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "var(--ink-900)",
        }}
      >
        <Icon name={icon} size={28} />
      </div>
      <div
        style={{
          fontFamily: "var(--font-display)",
          fontSize: 15,
          fontWeight: 600,
          letterSpacing: "-0.02em",
          marginTop: 16,
        }}
      >
        {title}
      </div>
      {body && (
        <div
          style={{
            fontSize: 13.5,
            fontWeight: 500,
            color: "var(--text-secondary)",
            marginTop: 6,
            maxWidth: 280,
            marginInline: "auto",
            textWrap: "pretty",
          }}
        >
          {body}
        </div>
      )}
      {action && <div style={{ marginTop: 18 }}>{action}</div>}
    </div>
  );
}
